import { useRef } from 'react';
import { Row, Col, Typography, Space, Divider } from "antd";
import { useReactToPrint } from "react-to-print";
import { getCurrentTime, dateTimeFormat9 } from "@/lib/dateTime";
import { getLangList } from '@/lib/i18n';
import { ReButton } from "@/components/refineElement";
import { ClassSubjectItems, ClassType } from "@/containers/organization/classManagement/types";
import { StudentType } from "@/containers/humanResourceManagement/studentManagement/types";

interface Props {
  form: any;
  info: StudentType;
  subjectListForExam: ClassSubjectItems;
  classInfo: ClassType;
  year: string;
}

// ESL
function ModalTranscriptType2(props: Props) {
  const { info, subjectListForExam, classInfo, year } = props;
  const contentRef = useRef<HTMLDivElement>(null);
  const dataS = subjectListForExam?.S?.map((subject) => ({ enName: subject.enName, cnName: subject.cnName, description: subject.description, score: info[subject.subjectId] })) ?? [];
  const dataC = subjectListForExam?.C?.map((subject) => ({ enName: subject.enName, cnName: subject.cnName, description: subject.description, score: info[subject.subjectId] })) ?? [];
  const dataLA = subjectListForExam?.LA?.map((subject) => ({ enName: subject.enName, cnName: subject.cnName, description: subject.description, score: info[subject.subjectId] })) ?? [];
  const title = `${year} ${classInfo.semesterName} Final Report Card`;
  const reactToPrintFn = useReactToPrint({ contentRef, documentTitle: `${title} - ${info.nameCn}_${info.nameEn}` });
  const buttonT: any = getLangList("button");

  return (
    <Row justify="end" gutter={[0, 8]}>
      <Col>
        <ReButton iconName="download" onClick={() => reactToPrintFn()}>{buttonT.DOWNLOAD}</ReButton>
      </Col>

      <Col span={24}>
        <div className="modal-transcript-container transcript-container-type-2" ref={contentRef}>
          <Space direction="vertical" >
            <Row>
              <Col span={4}>
                <div className="transcript-icon" />
              </Col>

              <Col span={20}>
                <Typography.Title level={3}>
                  {title}
                </Typography.Title>
              </Col>
            </Row>

            <Row justify="end">
              <Col span={20}>
                <Row justify="space-between">
                  <Col>Student Name: {info.nameCn} {info.nameEn}</Col>
                  <Col>{getCurrentTime().format(dateTimeFormat9)}</Col>
                </Row>

                <Row>
                  <Col>Level: {classInfo.className}</Col>
                </Row>
              </Col>
            </Row>

            <Row justify="end">
              <Col><Typography.Text strong>Performance 成績</Typography.Text></Col>
            </Row>

            <Row style={{ marginBottom: '10px' }}>
              <Col span={24}>
                <Row>
                  <Col span={24}><Typography.Text strong>Scholastic 學科</Typography.Text></Col>
                </Row>

                <Space direction="vertical" size={4} style={{ width: '100%' }}>
                  {dataS.map((item) => (
                    <Row align="middle" justify="space-between">
                      <Col span={21} offset={1}>
                        <Divider orientation="left" orientationMargin={0} dashed plain>{`${item.enName} ${item.cnName}`}</Divider>
                      </Col>

                      <Col>{item.score}</Col>

                      <Col span={21} offset={1} style={{ fontSize: '9px', lineHeight: 0 }}>
                        {item.description}
                      </Col>
                    </Row>
                  ))}
                </Space>
              </Col>
            </Row>

            <Row style={{ marginBottom: '10px' }}>
              <Col span={24}>
                <Row>
                  <Col span={24}><Typography.Text strong>Conduct</Typography.Text></Col>
                </Row>

                <Space direction="vertical" size={4} style={{ width: '100%' }}>
                  {dataC.map((item) => (
                    <Row align="middle" justify="space-between">
                      <Col span={21} offset={1}>
                        <Divider orientation="left" orientationMargin={0} dashed plain>{`${item.enName} ${item.cnName}`}</Divider>
                      </Col>

                      <Col>{item.score}</Col>

                      <Col span={21} offset={1} style={{ fontSize: '9px', lineHeight: 0 }}>
                        {item.description}
                      </Col>
                    </Row>
                  ))}
                </Space>
              </Col>
            </Row>

            <Row style={{ marginBottom: '10px' }}>
              <Col span={24}>
                <Row>
                  <Col span={24}><Typography.Text strong>Language Arts</Typography.Text></Col>
                </Row>

                <Space direction="vertical" size={4} style={{ width: '100%' }}>
                  {dataLA.map((item) => (
                    <Row align="middle" justify="space-between">
                      <Col span={21} offset={1}>
                        <Divider orientation="left" orientationMargin={0} dashed plain>{`${item.enName} ${item.cnName}`}</Divider>
                      </Col>

                      <Col>{item.score}</Col>

                      <Col span={21} offset={1} style={{ fontSize: '9px', lineHeight: 0 }}>
                        {item.description}
                      </Col>
                    </Row>
                  ))}
                </Space>
              </Col>
            </Row>

            <Row style={{ fontSize: '10px' }}>
              <Col span={24}>Assessment Standards 評分標準</Col>

              <Col span={24}>
                <Row justify="space-between">
                  <Col span={11}>A: Outstanding (95-100) - 表現優異</Col>
                  <Col span={12}>C: Satisfactory (75-84) - 表現尚佳</Col>
                  <Col span={11}>B: Exceed Expectations (85-94) - 表現良好</Col>
                  <Col span={12}>D: Needs Improvement (below 75) - 需待加強</Col>
                </Row>
              </Col>
            </Row>

            <Row justify="space-between" align="middle" style={{ marginTop: '30px' }}>
              <Col>
                <Typography.Text strong>
                  Teacher: {classInfo.teacherName}
                </Typography.Text>
              </Col>

              <Col>
                <Space>
                  <Typography.Text strong>Principal:</Typography.Text>
                  <div className='principal-sign'></div>
                </Space>
              </Col>
            </Row>
          </Space>
        </div>
      </Col>
    </Row>
  );
};

export default ModalTranscriptType2;